import { Component, OnInit, Input } from '@angular/core';
import { ChartApp } from 'src/app/entity/entities';

@Component({
  selector: 'app-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.css']
})
export class ChartComponent implements OnInit {

  @Input() data: ChartApp;

  constructor() { }

  ngOnInit() {
  }

}
